<template>
  <SoDialog
    v-model="value"
    card-title="Confirm Trade"
    @on-close="resetConfirmModal()"
  >
    <SoForm
      ref="confirm-trade-modal-form"
      v-model="isConfirmTradeValid"
      @submit="confirmTrade()"
    >
      <SoDatePicker
        v-model="confirmReceivedDateField"
        :error="confirmReceivedDateFieldError"
        label="Confirm Received Date"
      />
      <SoDatePicker
        v-model="confirmSignedDateField"
        :error="confirmSignedDateFieldError"
        label="Confirm Signed Date"
      />
      <SoTextField
        v-model="confirmSignedByField"
        :rules="[rules.required]"
        label="Confirm Signed By"
        readonly
      />
      <v-slide-x-transition>
        <slot name="alerts" />
      </v-slide-x-transition>
      <div class="d-flex justify-end pt-4 gap-2">
        <SoButton title="Cancel" large @click="value = false" />
        <SoButton
          title="Save"
          type="primary"
          :disabled="!isConfirmTradeValid"
          large
          submit
          data-testid="trade-modal-confirm-trade-btn"
        />
      </div>
    </SoForm>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { ITradesConfirmElecData } from "@/models/operations/tradingData/elecData.types"
  import { ITradesConfirmGasData } from "@/models/operations/tradingData/gasData.types"
  import SoButton from "@/components/formControls/SoButton.vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoForm from "@/components/formControls/SoForm.vue"
  import SoDatePicker from "@/components/formControls/SoDatePicker.vue"
  import rules from "@/validators/rules"
  import dayjs from "dayjs"
  import { AuthService } from "@/services/AuthService"
  import SoTextField from "@/components/formControls/SoTextField.vue"

  export default defineComponent({
    components: {
      SoTextField,
      SoButton,
      SoDialog,
      SoForm,
      SoDatePicker,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue", "submit"],
    data() {
      return {
        isConfirmTradeValid: false,
        confirmReceivedDateField: null,
        confirmSignedDateField: null,
        confirmReceivedDateFieldError: "",
        confirmSignedDateFieldError: "",
        confirmSignedByField: AuthService.getCurrentUser().name,
        rules,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
    methods: {
      confirmTrade() {
        if (!this.confirmReceivedDateField) {
          this.confirmReceivedDateFieldError = "Date is required"
          return
        }
        this.confirmReceivedDateFieldError = ""
        if (!this.confirmSignedDateField) {
          this.confirmSignedDateFieldError = "Date is required"
          return
        }
        this.confirmSignedDateFieldError = ""

        this.$emit("submit", {
          confirmReceivedDate: dayjs(this.confirmReceivedDateField),
          confirmSignedBy: this.confirmSignedByField,
          confirmSignedDate: dayjs(this.confirmSignedDateField),
        } as ITradesConfirmElecData | ITradesConfirmGasData)
      },
      resetConfirmModal() {
        const form = this.$refs["confirm-trade-modal-form"] as typeof SoForm
        form?.reset()
        this.confirmSignedByField = AuthService.getCurrentUser().name
      },
    },
  })
</script>
